import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { Table, Tooltip } from 'antd';
import { useMemo } from 'react';
import { renderColumns } from './columns';
import { styleVariables } from '@lib/common';
import { Responsive } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTable = styled(Table)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  .ant-table-thead > tr > th {\n    background: ", ";\n  }\n  .ant-table-container table {\n    & > tbody > tr > td {\n      cursor: pointer;\n    }\n  }\n"])), styleVariables.colors.gray3);
export var TableAttendeeSubmission = function TableAttendeeSubmission(_ref) {
  var submissions = _ref.submissions,
      attendeeSubmissionTranslation = _ref.attendeeSubmissionTranslation,
      onRowEvent = _ref.onRowEvent,
      totalQuestions = _ref.totalQuestions;
  var columns = useMemo(function () {
    return renderColumns({
      attendeeSubmissionTranslation: attendeeSubmissionTranslation,
      totalQuestions: totalQuestions
    });
  }, [attendeeSubmissionTranslation, totalQuestions]);

  var CustomRow = function CustomRow(props) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: attendeeSubmissionTranslation.clickToViewDetail,
      children: /*#__PURE__*/_jsx("tr", _objectSpread({}, props))
    });
  };

  return /*#__PURE__*/_jsx(Responsive.DesktopScreen, {
    children: /*#__PURE__*/_jsx(StyledTable, {
      onRow: onRowEvent,
      bordered: true,
      dataSource: submissions,
      columns: columns,
      pagination: false,
      components: {
        body: {
          row: CustomRow
        }
      }
    })
  });
};